export interface CommunicationBaseFormType {
    phone0: string;
    phone1: string;
    phone2: string;
    typePhone0: string;
    typePhone1: string;
    typePhone2: string;
    email0: string;
    email1: string;
}

export const communicationBaseDefaultValues: CommunicationBaseFormType = {
    phone0: null,
    phone1: null,
    phone2: null,
    typePhone0: "",
    typePhone1: "",
    typePhone2: "",
    email0: "",
    email1: "",
};
